<template>
  <div class="content">
    <div class="row animated fadeIn">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title pull-left">
              Cloudflare Audit
            </h4>
          </div>
          <div class="card-body pt-0">
            <div class="row pb-10 align-items-center">
              <div class="col-md-2 pb-10">
                <label>Filter</label>
                <select v-model="selectedOption" class="form-control">
                  <option value="all">All</option>
                  <option value="attention">Requires Attention</option>
                </select>
              </div>
              <div class="col-md-10 pb-10">
                <button type="button" @click="syncForServiceCheck" class="btn btn-primary btn-sm pull-right" :disabled="syncLoader">
                  <span class="" v-if="syncLoader">Syncing</span>
                  <span v-else>
                    Sync Service
                  </span>
                </button>
              </div>
              <div class="col-md-2">
                <label class="d-flex align-items-center"> Show
                  <select style="width: 65px;" class="mr-7 ml-7 custom-select custom-select-sm form-control form-control-sm datatable-dropdown" id="grouped"  aria-describedby="grouped" required v-model="pageMainSize">
                    <option value="10" >10</option>
                    <option value="25" >25</option>
                    <option value="50" >50</option>
                    <option :value="sortedDomains.length" >All</option>
                  </select> entries</label>
              </div>
              <div class="col-md-8">
              </div>
              <div class="col-md-2 pull-left">
                <input v-model="searchQuery" type="text" class="form-control mr-5" style="height: 30px;" placeholder="Search" />
              </div>
            </div>
            <div class="loader" v-if="loading"></div>
            <table id="datatableEnt" v-else-if="!loading" class="table table-striped table-bordered">
              <thead>
              <tr>
                <th width="10%">Domain</th>
                <th width="8%" class="text-center">Server IP</th>
                <th width="10%" class="text-center">ENT Plan</th>
                <th width="20%" class="text-center">CF ENT Status</th>
                <th width="5%" class="text-center">plugin_status</th>
                <th width="5%" class="text-center">O20 Status</th>
                <th width="5%" class="text-center">cache_test_status</th>
                <th width="5%">Service Result</th>
                <th width="5%">Action</th>
              </tr>
              </thead>
              <tbody  v-for="(row, index) in paginatedDomains" :key="row.id">
              <tr>
                <td>
                  {{ row.domain }}
                </td>
                <td width="10%" class="text-center">
                  {{ row.ip || '' }}
                </td>
                <td width="20%">
                 {{formatCfPlan(row.cfPlan)}}
                </td>
                <td class="make-cursor-pointer"  style="max-width: 20px"><span>
                  <i :class="row.bsCacheStatus ? 'fa fa-check-circle text-success' : 'fa fa-times-circle text-danger'"></i>
                </span></td>
                <td class="text-center">
                  <i :class="row.pluginStatus ? 'fa fa-check-circle text-success' : 'fa fa-times-circle text-danger'"></i>
                </td>
                <td class="text-center">
                  <i :class="row.o2o_status ? 'fa fa-check-circle text-success' : 'fa fa-times-circle text-danger'"></i>
                </td>
                <td class="text-center"  width="16%">
                  <i :class="row.cloudflareEntStatus ? 'fa fa-check-circle text-success' : 'fa fa-times-circle text-danger'"></i>
                </td>
                <td class="text-center"  width="16%">
                  <span v-if="row.service_check" class="cursor-pointer" :title="JSON.stringify(row.service_check)" data-toggle="tooltip" data-placement="top" :key="index +'active112'" data-html="true"  >
                    {{getIconForService(row.service_check)}}
                  </span>
                  <span v-else>Processing</span>
                </td>
                <td>
                  <button class="btn btn-primary btn-sm mr-2" @click="removeCFDomain(task, index)">
                    <div class="loader mini_loader" v-if="resolveLoader && resolvingIndex === index "></div>
                    <span v-else><i class="fa fa-refresh"></i> Resolve</span>
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
            <template v-if="!sortedDomains.length">
              <div class="row">
                <div class="col-md-12 text-center text-danger mb-3 font-weight-bold">
                </div>
              </div>
            </template>
            <div class="row mt-10" v-if="sortedDomains.length > 0 ">
              <div class="col-md-12 d-flex justify-content-between">
                    <span class="lh-3 pull-left">
                       <b>Page {{pageMainNum + 1}} of {{mainPageCount}}</b>
                    </span>
                <section class="dataTables_paginate paging_full_numbers">
                  <paginate
                      id="notes"
                      :pageCount="mainPageCount"
                      :clickHandler="goToMainPage"
                      :prevText="'Prev'"
                      :nextText="'Next'"
                      page-class="page-item"
                      prev-class="page-item"
                      prev-link-class="page-link"
                      next-class="page-item"
                      next-link-class="page-link"
                      page-link-class="page-link"
                      containerClass="pagination">
                  </paginate>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {db} from "@/firebase/init";
import Paginate from 'vuejs-paginate'
import ActivateCFModal from "@/components/Admin/Tasks/activateCFModal.vue";

export default {
  name: "enterpriseV2",
  components: {ActivateCFModal, Paginate,},
  computed: {
    user() {
      return this.$store.getters.user;
    },
    mainPageCount() {
      if (this.sortedDomains && this.sortedDomains.length > 0) {
        let filteredGroups = this.sortedDomains
        let l = filteredGroups.length, s = this.pageMainSize;
        return Math.ceil(l / s);
      }
    },
    paginatedDomains() {
      const start = this.pageMainNum * this.pageMainSize, end = start + this.pageMainSize;
      const allTasks = this.sortedDomains.slice(start, end);
      return allTasks
    },
    sortedDomains() {
      let domains = this.domains
      if (this.searchQuery) {
        domains = domains.filter(el => (el.domain && el.domain.includes(this.searchQuery.trim())))
      }
      if(this.selectedOption !== 'all'){
        domains = domains.filter((a) => {
          return !a.bsCacheStatus ||
              !a.pluginStatus ||
              !a.cloudflareEntStatus ||
              a.cfPlan === '' ||
              a.cfPlan === 'free'
        });
      }
      return domains
    }
  },
  data() {
    return {
      searchQuery: '',
      loading: false,
      domains: [],
      listener: null,
      pageMainNum: 0,
      pageMainSize: 10,
      syncLoader: true,
      selectedOption: 'all',
      resolveLoader: false,
      resolvingIndex: null,
    }
  },
  beforeDestroy() {
    if (this.listener) {
      this.listener()
    }
  },
  watch: {
    searchQuery(newValue) {
      this.searchQuery = newValue.replace(/\s/g, '');
    }
  },
  mounted() {
    this.fetchActivatedCfEnterpriseDomains()
  },
  methods: {
    getIconForService(service) {
      if(service.success) return '✅'
      return '⚠️'
    },
    goToMainPage(pageNum) {
      this.pageMainNum = pageNum - 1;
    },
    formatCfPlan(planString) {
      if (!planString) return 'Requires Attention';
      if (Array.isArray(planString)) {
        return planString
            .map(item =>
                item.split('_')
                    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(' ')
            )
            .join(', ');
      }
      return planString
          .split('_')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
    },
    async fetchActivatedCfEnterpriseDomains() {
      try {
        this.loading = true;
        this.domains = []
        this.listener = await db.collection('cfDomains').onSnapshot(querySnapshot => {
          querySnapshot.docChanges().forEach(changeDoc => {
            if (changeDoc.type === 'added') {
              if (changeDoc.doc.id === 'queue_processing') {
                this.syncLoader = changeDoc.doc.data().running
              } else {
                this.domains.push({id: changeDoc.doc.id, ...changeDoc.doc.data()})
              }
            }
            if (changeDoc.type === 'modified') {
              if (changeDoc.doc.id === 'queue_processing') {
                this.syncLoader = changeDoc.doc.data().running
              } else {
                const selectedDomain = this.domains.find(el => el.id === changeDoc.doc.id)
                selectedDomain.cfEnterprise = {...changeDoc.doc.data().cfEnterprise}
              }
            }
            if (changeDoc.type === 'removed') {
              if (changeDoc.doc.id === 'queue_processing') {
                this.syncLoader = changeDoc.doc.data().running
              } else {
                this.domains = this.domains.filter(el => el.id !== changeDoc.doc.id)
              }
            }
          });
        });
        $(function () {
          $('[data-toggle="tooltip"]').tooltip()
        })
        setTimeout(() => {
          this.loading = false;
        }, 5000)
      } catch (e) {
        this.loading = false
      }
    },
    async removeCFDomain(domainData, index) {
      this.resolvingIndex = index;
      this.resolveLoader = true;
      try{
        await db.collection('cfDomains').doc(domainData.id).delete();
      }
      catch (e){
        console.log(e.toString())
      }
      this.resolveLoader = false;
      this.resolvingIndex = null;
    },
    async syncForServiceCheck() {
      this.loading = true;
      try {
        await this.$http.post('/utilities/cf-ent/service-check', {
          grant_type: 'token',
        });
      } catch (e) {
        console.log(e.toString())
      }
      this.loading = false;
    }
  }
}
</script>

<style scoped>
code {
  background: #f4f4f4;
  border: 1px solid #ddd;
  border-left: 3px solid #2954fa;
  color: #666;
  page-break-inside: avoid;
  font-family: monospace;
  font-size: 12px;
  line-height: 1.6;
  margin-bottom: 1.6em;
  max-width: 100%;
  overflow: auto;
  padding: 1em 1.5em;
  display: block;
  word-wrap: break-word;
}
code .info{
  color: #376c4f;
}
code .danger{
  color: #cf363e;
}
.grey{
  opacity: 0.9;
}

.warning-bg {
  background-color: #fff9cb !important;
}
.bg-primary-light {
  background-color: #dbdbdb !important;
}


.details-control {
  background: url('../../../assets/img/details_open.png') no-repeat center center;
  cursor: pointer;
  width: 20px;
  height: 20px;
  display: block;
  margin: 13px auto;
}

.details-control.shown {
  background: url('../../../assets/img/details_close.png') no-repeat center center;
}
tr > th,td{
  padding: 4px 7px !important;
  text-align: center!important;
}
tr > th{
  font-size: 12px !important;
  font-weight: 400 !important;
}
.pagination{
  display: inline-flex !important;
}
.json-container {
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-family: monospace;
  white-space: pre-wrap !important; /* Preserve line breaks for readability */
  word-wrap: break-word !important; /* Avoid overflow */
  max-width: 500px;
  overflow-wrap: break-word !important;
  overflow-x: auto;
}
</style>
